import React from "react";
import TwitterIcon from '@material-ui/icons/Twitter';
import "../../Style/BotonCompartir.css";
const Twitter = ({d}) => {
  const dias =d
  return (
    <div>
      <a className="Result-Information__Twitter"  href={ `https://twitter.com/intent/tweet?text=Calculé mis impuestos provinciales y municipales. El Gobierno de Córdoba queda con  ${dias} días de mi sueldo. Si sumara los impuestos nacionales tendría que duplicar los días que debo trabajar solo para pagar impuestos. https://calculadoraimpuestos-158e5.web.app/  `}>
        <TwitterIcon />
      </a>
    </div>
  );
};

export default Twitter;
